module.exports = __webpack_public_path__ + "static/media/single-news-cover.7a46a20e.jpg";